import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Users, Clock, TrendingUp, Activity, Gift } from 'lucide-react';

const METRICS = [
  { key: 'viewers', label: 'Current Viewers', icon: Users, desc: 'Live viewer count' },
  { key: 'duration', label: 'Stream Duration', icon: Clock, desc: 'Session length' },
  { key: 'peak', label: 'Peak Viewers', icon: TrendingUp, desc: 'Highest concurrent' },
  { key: 'engagement', label: 'Engagement Rate', icon: Activity, desc: 'Live engagement' },
  { key: 'gifts', label: 'Total Gifts', icon: Gift, desc: 'Stream monetization' },
];

/** Live Performance detail dialog — the same five metrics that previously
 * lived as cards on the main Live Analytics page. No live measurement
 * pipeline exists yet, so every metric stays an honest "No live data yet"
 * empty state rather than an invented number. */
export default function LivePerformanceDialog({ open, onOpenChange, sessionLabel }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#14171F] border-white/10 sm:max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="live-performance-dialog">
        <DialogHeader><DialogTitle className="text-white">Live Performance</DialogTitle></DialogHeader>
        <p className="text-xs text-[#8A93A6] -mt-3">Showing: {sessionLabel}</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {METRICS.map((m) => (
            <Card key={m.key} className="glass border-white/5" data-testid={`live-perf-metric-${m.key}`}>
              <CardHeader className="pb-3">
                <CardTitle className="text-sm text-[#8A93A6] flex items-center gap-2">
                  <m.icon className="h-4 w-4" />
                  {m.label}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold text-[#555E6E]">No live data yet</div>
                <p className="text-xs text-[#8A93A6] mt-1">{m.desc}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
